import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from './../../core/services/utilities.service';
import { API_URL } from './../enums/api-enums';
import { RequestOption } from './../model/common.model';
import { SingleResponse } from './../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  baseUrl = environment.portalURL;
  constructor(
    private util: UtilitiesService
  ) { }

  uploadImageToS3(file) {
    const formData = new FormData();
    formData.append('image', file);
    return this.util.req.httpPost(`${this.baseUrl + API_URL.NEWS}/upload`, formData);
  }

  addNews(titleRequest, descriptionRequest, contentRequest) {
    const object = {
      title: titleRequest,
      description: descriptionRequest,
      content: btoa(unescape(encodeURIComponent(this.util.encrypt(contentRequest))))
    };
    return this.util.req.httpPost(`${this.baseUrl + API_URL.NEWS}`, object);
  }

  activeNews(newsId, status): Observable<SingleResponse<any>> {
    const value = status ? '1' : '0';
    return this.util.req.httpPut<SingleResponse<any>>(this.baseUrl + API_URL.NEWS + '/' + newsId + '/status/' + value);
  }

  bulkActions(type, listId): Observable<SingleResponse<any>> {
    const model = {
      ids: listId
    };
    return this.util.req.httpPost(`${this.baseUrl + API_URL.NEWS}/bulk-${type}`, model);
  }

  updateNews(newsId, titleRequest, descriptionRequest, contentRequest): Observable<SingleResponse<any>> {
    const model = {
      id: newsId,
      title: titleRequest,
      description: descriptionRequest,
      content: btoa(unescape(encodeURIComponent(this.util.encrypt(contentRequest))))
    };
    return this.util.req.httpPut<SingleResponse<any>>(this.baseUrl + API_URL.NEWS, model);
  }

  deleteNews(id) {
    return this.util.req.httpDelete(this.baseUrl + API_URL.NEWS + '/' + id);
  }

  getNewsById(id): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.NEWS + '/' + id);
  }

  getNewsPublishById(id): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.NEWS + API_URL.PUBLISH + '/' + id);
  }

  getListNews(page, size, title?) {
    let params = new HttpParams();
    if (title) {
      params = params.append('title', encodeURI(title));
    }
    params = params.append('page', page);
    params = params.append('size', size);
    params = params.append('sortBy', 'lastUpdated');
    params = params.append('sortDirection', 'desc');
    return this.util.req.httpGet(`${this.baseUrl + API_URL.NEWS + API_URL.PUBLISH}?${params}`);
  }

  getAllData(requestOption: RequestOption, title?, status?) {
    let params = new HttpParams();
    if (title) {
      params = params.append('title', title);
    }
    if (status) {
      params = params.append('status', status);
    }
    params = params.append('page', requestOption.pagingOptions.number as any);
    params = params.append('size', requestOption.pagingOptions.size as any);
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    } else {
      params = params.append('sortBy', 'lastUpdated');
      params = params.append('sortDirection', 'desc');
    }

    return this.util.req.httpGet(`${this.baseUrl + API_URL.NEWS}?${params}`);
  }
}
